module.exports = __webpack_public_path__ + "img/wechat.ef492ffe.svg";